// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"1729ff89b901ddebad5b","339":"ec75aaa5ec1dab05f051"}[chunkId] + ".js";
};